import React from 'react';
import { StatsCard } from './StatsCard';
import { FileText, TableIcon, BadgeCheck, AlertTriangle, BarChart2, PlayCircle, Loader, CheckCircle2 } from 'lucide-react';

interface DashboardStatsProps {
  stats: {
    totalIncidents: number;
    totalCatalogTasks: number;
    linkedIncidents: number;
    highPriorityIncidents: number;
    repetitiveTickets?: number;
    openTickets: number;
    inProgressTickets: number;
    closedTickets: number;
  };
}

export function DashboardStats({ stats }: DashboardStatsProps) {
  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 gap-6 py-2">
        <StatsCard 
          title="Total Incidents" 
          value={stats.totalIncidents} 
          icon={<FileText className="h-6 w-6" />} 
          className="min-w-[180px]"
        />
        <StatsCard 
          title="Total Catalog Tasks" 
          value={stats.totalCatalogTasks} 
          icon={<TableIcon className="h-6 w-6" />} 
          className="min-w-[180px]"
        />
        {/* <StatsCard 
          title="Post-Deploy Incidents" 
          value={stats.linkedIncidents} 
          icon={<BadgeCheck className="h-6 w-6" />} 
          className="min-w-[180px]"
        /> */}
        <StatsCard 
          title="High Priority Incidents" 
          value={stats.highPriorityIncidents} 
          icon={<AlertTriangle className="h-6 w-6" />} 
          className="min-w-[180px]"
        />
        <StatsCard 
          title="Repetitive Tickets" 
          value={stats.repetitiveTickets || 0} 
          icon={<BarChart2 className="h-6 w-6" />} 
          className="min-w-[180px]"
        />
      </div>
      {/* <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 py-2">
        <StatsCard 
          title="Tickets Open" 
          value={stats.openTickets} 
          icon={<PlayCircle className="h-6 w-6" />} 
          className="min-w-[180px]"
        />
        <StatsCard 
          title="Tickets In Progress" 
          value={stats.inProgressTickets} 
          icon={<Loader className="h-6 w-6" />} 
          className="min-w-[180px]"
        />
        <StatsCard 
          title="Closed Tickets" 
          value={stats.closedTickets} 
          icon={<CheckCircle2 className="h-6 w-6" />} 
          className="min-w-[180px]"
        />
      </div> */}
    </>
  );
}
